import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-wrapper-block" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentWrapper',
  setup(__props) {

/**
 * Component for wrapping system messages and short pieces of text.
 *
 * Adds padding and border around the wrapped element.
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})